import * as tokens from '../../../tokens/typography.generated.js';
export const semanticTypography = {
    typography: {
        action: {
            lg: {
                label: tokens.SEM_TYPOGRAPHY_ACTION_LG_LABEL
            },
            md: {
                label: tokens.SEM_TYPOGRAPHY_ACTION_MD_LABEL
            },
            sm: {
                label: tokens.SEM_TYPOGRAPHY_ACTION_SM_LABEL
            }
        },
        forms: {
            caption: tokens.SEM_TYPOGRAPHY_FORMS_CAPTION,
            appendix: tokens.SEM_TYPOGRAPHY_FORMS_APPENDIX,
            label: tokens.SEM_TYPOGRAPHY_FORMS_LABEL,
            labelSmall: tokens.SEM_TYPOGRAPHY_FORMS_LABEL_SMALL
        },
        navigation: {
            sm: {
                label: tokens.SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL
            },
            md: {
                label: tokens.SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL
            }
        }
    }
};
//# sourceMappingURL=semantic.js.map